export default {
  "common": {
    "participate": "Jetzt teilnehmen",
    "home": "Startseite",
    "contact": "Kontakt",
    "how_it_works": "Wie es funktioniert",
    "winners": "Gewinner",
    "good_cause": "Guter Zweck",
    "account": "Mein Konto",
    "logout": "Abmelden"
  },
  "home": {
    "hero": {
      "grand_prize": "Hauptpreis der Verlosung #52",
      "villa_title": "Die Villa, die Ihr Leben verändern könnte",
      "estimated_value": "Geschätzter Wert",
      "win_your": "Gewinnen Sie Ihr",
      "dream_house": "Traumhaus",
      "description": "Eine moderne 500 m² Villa im Wert von {{value}} zu gewinnen, plus Dutzende außergewöhnliche Preise.",
      "buy_tickets": "Meine Tickets kaufen",
      "see_prizes": "Preise ansehen",
      "prizes": {
        "title": "Über 1.200.000 € an Preisen zu gewinnen",
        "description": "Ein Traumleben erwartet Sie. Versuchen Sie noch heute Ihr Glück."
      }
    },
    "property": {
      "tabs": {
        "exterior": "Außen",
        "interior": "Innen",
        "land": "Grundstück"
      },
      "features": {
        "surface": "Fläche",
        "bedrooms": "Schlafzimmer",
        "bathrooms": "Badezimmer",
        "pool": "Pool & Spa",
        "garden": "Garten",
        "garage": "Garage"
      }
    }
  },
  "admin": {
    "title": "Lotterie-Verwaltung",
    "manage_lottery": "Lotterie verwalten",
    "manage_packages": "Pakete verwalten",
    "manage_prizes": "Preise verwalten",
    "users": "Benutzer",
    "settings": "Seiteneinstellungen"
  }
};
